<template>
    <section class="not-for-screen-render">
        <div ref="reportContents"  style="width:85%; height:100%; padding:4px; background-color: white; padding:0px 32px;">
            <div
            v-for="(skill, skillIndex) in reportContents"
            :key="skillIndex" 
            >
                <div v-for="(entry, index) in skill.questions"
                :aria-label="'pdf-page-' + (index + 1)"
                :key="index" style="display: block !important; padding: 16px;"
                :style="{
                    'page-break-before': (index === 0 && skillIndex !== 0) ? 'always !important' : 'auto',
                    'page-break-inside': isPassageQuestion(entry) ? 'auto' : 'avoid !important',
                    'break-inside': isPassageQuestion(entry) ? 'auto' : 'avoid !important'
                }">
                    <div v-if="skillIndex === 0 && index === 0" style="margin-bottom: 8px;">
                        <div v-if="assessmentType.toLowerCase() === 'dynamic'" style="display: flex; flex-direction: row; justify-content: center; margin: 8px 12px;">
                            <h2 v-if="testType?.toLowerCase() === 'screening'">Screening Result</h2>
                            <h2 v-if="testType?.toLowerCase() === 'mains'">Mains Result</h2>
                        </div>
                        <div style="display: flex; flex-direction: row; justify-content: space-between; margin: 8px 0px;">
                            <b>{{ reportContents?.userName | capitalizeFirst }}</b>
                            <b v-if="reportContents.length > 1">Total Score: ({{ totalScore || 0 }} / {{ maxMarks }})</b>
                        </div>
                    </div>
                    <div v-if="index === 0" style="margin-bottom: 16px;">
                        <b
                        >Skill: {{ skill.skillName }} ({{ skill.score }}/{{
                            skill.maximumMarks
                        }})</b
                        >
                    </div>
                    <!-- A passage based question shows its statement once, in a card, and then
                         renders its sub-questions in place of itself. -->
                    <v-col class="px-2" v-if="isPassageQuestion(entry)"
                    style="page-break-inside: avoid !important; break-inside: avoid !important;">
                        <v-row style="margin-bottom: 12px; display: flex;">
                            <div style="flex: 0 0 auto; padding-right: 4px; padding-left: 8px;">Q. {{ index + 1 }}</div>
                        </v-row>
                        <v-row style="margin-bottom: 12px; padding-left: 8px; padding-right: 8px;">
                            <div style="width: 100%; border: 1px solid #0000001A; border-radius: 8px; padding: 16px;">
                                <div style="font-size: 14px; font-weight: 500; margin-bottom: 8px;">Paragraph</div>
                                <!-- Deliberately not .question-statement (that inlines <p>, collapsing a
                                     multi-paragraph passage) and not stripWrappingPTags (its greedy regex
                                     would eat the inner tags of a multi-paragraph statement). A plain-text
                                     passage carries its breaks as newlines, so it needs pre-line instead. -->
                                <div
                                :style="hasHtmlMarkup(entry.questionStatement || entry.sanitizedQuestionStatement)
                                    ? { 'font-size': '14px', 'font-weight': '400' }
                                    : { 'font-size': '14px', 'font-weight': '400', 'white-space': 'pre-line' }"
                                v-html="formatQuestionStatementForDisplay(entry.questionStatement || entry.sanitizedQuestionStatement)"></div>
                            </div>
                        </v-row>
                        <v-row style="padding-left: 8px; padding-right: 0px;">
                            <v-divider></v-divider>
                        </v-row>
                    </v-col>

                    <!-- A normal question gets its top gap from the wrapper div's 16px padding,
                         but a passage spends that once at the group's start - so a sub-question
                         pushed onto a fresh page would sit flush against the top. Each one
                         carries its own top padding instead, which also spaces them apart the
                         way consecutive questions are spaced. -->
                    <v-col class="px-2"
                    v-for="(item, subIndex) in questionsToRender(entry)"
                    :key="subIndex"
                    style="page-break-inside: avoid !important; break-inside: avoid !important;"
                    :style="isPassageQuestion(entry) ? { 'padding-top': '16px' } : {}">
                        <v-row style="margin-bottom: 12px; display: flex;">
                            <div style="flex: 0 0 auto; padding-right: 4px; padding-left: 8px;">Q. {{ questionLabel(index, subIndex, entry) }}</div>
                            <div style="flex: 1; display: flex; flex-wrap: wrap;">
                                <div style="padding-left: 8px;" class="question-statement" v-html="formatQuestionStatementForDisplay(stripWrappingPTags(item.questionStatement || item.sanitizedQuestionStatement))"></div>
                            </div>
                        </v-row>
                        <v-row style="margin-bottom: 12px; padding-left: 6px"  v-if="item?.questionAssetUrl?.startsWith('http') || item?.questionAssetUrl?.startsWith('blob')">
                            <img v-if="item.questionAssetUrl?.startsWith('https://drive.google.com/')" style="max-height: 200px; max-width: 500px;" :src="item.questionAssetUrl"/>
                            <img v-else
                            style="max-height: 200px; max-width: 500px;" 
                            :src="item.questionAssetUrl"
                            crossorigin="anonymous"/>
                        </v-row> 
                        <v-row style="display:flex; flex-direction: row; gap: 8px; padding-left: 8px;">
                            <div v-if="item.difficultyLevel !== 'NA' &&  item.skill !== 'Psychometry'"
                            style="
                            height: 32px;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            border-radius:16px; 
                            background-color:#CFD5F1;
                            color:#3F41D1;
                            padding: 0px 16px;
                            font-size:12px;
                            font-weight:400;
                            text-wrap: nowrap;">
                                {{ item.difficultyLevel }}
                            </div>
                            <div  v-if="item.markingType"
                            style="
                            height: 32px;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            border-radius:16px; 
                            background-color:#CFD5F1;
                            color:#3F41D1;
                            padding: 0px 16px;
                            font-size:12px;
                            font-weight:400;
                            text-wrap: nowrap;">
                                {{ item.markingType }}
                            </div>
                            <!-- Marks allotted. Likert marked questions score per option, so they
                                 carry no single mark value - same rule as the on-screen report. -->
                            <div  v-if="item.markingType != 'Likert Marking'"
                            style="
                            height: 32px;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            border-radius:16px;
                            background-color:#CFD5F1;
                            color:#3F41D1;
                            padding: 0px 16px;
                            font-size:12px;
                            font-weight:400;
                            text-wrap: nowrap;">
                                {{ `${Number(item?.marksAllotted) || 1} Mark${ Number(item?.marksAllotted) > 1 ? 's' : '' }` }}
                            </div>
                            <div  v-if="item.questionType"
                            style="
                            height: 32px;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            border-radius:16px; 
                            background-color:#CFD5F1;
                            color:#3F41D1;
                            padding: 0px 16px;
                            font-size:12px;
                            font-weight:400;
                            text-wrap: nowrap;">
                                {{ item.questionType }}
                            </div>
                            <div  v-if="item.level !== 'NA'"
                            style="
                            height: 32px;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            border-radius:16px; 
                            background-color:#CFD5F1;
                            color:#3F41D1;
                            padding: 0px 16px;
                            font-size:12px;
                            font-weight:400;
                            text-wrap: nowrap;">
                                {{ item.level }}
                            </div>
                            <div  v-if="item.grade && item.grade !== 'NA'"
                            style="
                            height: 32px;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            border-radius:16px; 
                            background-color:#CFD5F1;
                            color:#3F41D1;
                            padding: 0px 16px;
                            font-size:12px;
                            font-weight:400;
                            text-wrap: nowrap;">
                                {{ item.grade }}
                            </div>
                            <div v-if="item?.strand && assessmentType.toLowerCase() === 'static'"
                            style="
                            height: 32px;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            border-radius:16px; 
                            background-color:#CFD5F1;
                            color:#3F41D1;
                            padding: 0px 16px;
                            font-size:12px;
                            font-weight:400;
                            text-wrap: nowrap;">
                                {{ item.strand }}
                            </div>
                        </v-row>
                        <div wrap row style="margin-bottom: 12px; padding-left: 8px; padding-top: 8px" v-if="item.questionType != 'MATCH_THE_FOLLOWING'">
                            <div style="margin-bottom: 12px">{{ item.questionType === 'FILL_IN_THE_BLANKS' ? 'Correct Answer -' : 'Options -' }}</div>

                            <!-- A fill in the blanks question has no real options - questionOptions
                                 is a row of NA placeholders - so the expected answer is shown in
                                 their place, the same way the on-screen report does it. -->
                            <div v-if="item.questionType === 'FILL_IN_THE_BLANKS'"
                            style="font-size: 14px; font-weight: 400; color: #06C270;">
                                {{ item.correctAnswer }}
                            </div>
                            <div style="display:flex; flex-direction:column; gap: 8px;" v-else-if="imageInOption(item.questionOptions)">
                                <div
                                v-for="(option, i) in item.questionOptions"
                                :key="i" style="display: flex; gap: 8px;">
                                    <div>{{ option.optionKey }}.</div>
                                    <img :width="100" crossorigin="anonymous"  :src="option.optionValue" 
                                    :style="item.correctAnswer?.includes(option.optionKey)? 
                                    { border: '2px solid #06C270 !important', borderRadius: '8px' }
                                    :{  border: '1px solid #0000001A',  borderRadius: '8px'}" />
                                </div>
                            </div>
                            <div style="display:flex; flex-direction:column; gap: 8px;" v-else-if="item?.markingType?.toLowerCase() === 'regular marking' && !imageInOption(item.questionOptions)">
                                <div v-for="(option, i) in item.questionOptions" :key="i">
                                    <div style="display:flex; flex-direction:row !important; align-items:center; gap: 4px; font-size: 14px; font-weight: 400;"
                                    :style="item.correctAnswer?.includes(option.optionKey)? { color: '#06C270'} : {} "
                                    >
                                        <div> {{option.optionKey}}.</div>
                                        <div v-html="option.optionValue"></div>
                                    </div>
                                </div>
                            </div>
                            <div style="display:flex; flex-direction:column; gap: 8px;" v-else-if="item?.markingType?.toLowerCase() === 'likert marking' && !imageInOption(item.questionOptions)">
                                <div v-for="(option, i) in item.questionOptions" :key="i">
                                    <div
                                    :style="option.optionScore > 0 ? { color: '#06C270' } : {}"
                                    style="display: flex; flex-direction: row; gap: 4px; font-size: 14px; font-weight: 400;"
                                    >
                                    {{ option.optionKey }}. {{ option.optionValue }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div wrap row style="padding-left: 8px; padding-top: 8px; margin-bottom: 12px" v-else>
                            <div style="padding-right: 12px;">Options -</div>
                            <div style="width: 100%; display: flex; ">
                                <!-- Left column for numbered items -->
                                <div style="width: 50%;">
                                    <div v-for="(item, index) in item.mtfOptions" :key="item.key" 
                                        style="margin-bottom: 8px; padding-right: 16px;">
                                        {{ index + 1 }}. {{ item.key }}
                                    </div>
                                </div>
                                
                                <!-- Right column for lettered answers -->
                                <div style="width: 50%;">
                                    <div v-for="(item, index) in item.mtfOptions" :key="item.key"
                                        style="margin-bottom: 8px;">
                                        {{ getAlphabet(index) }}. {{ item.value }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; padding-left: 0px; padding-top: 12px; margin-bottom: 12px">
                            <div style="font-size: 14px; font-weight: 400; padding-left: 4px">Time allocated -</div>
                            <div style="font-size: 14px; font-weight: 500; padding-left: 4px;">
                                {{ item.estimatedTime }} Sec  &nbsp;
                            </div>
                            &nbsp;
                            <div style="font-size: 14px; font-weight: 400; padding-left: 4px;">
                                Avg time taken by other users -
                            </div>
                            <div style="font-size: 14px; font-weight: 500; padding-left: 4px;">
                                {{ formatAttemptMetric(item?.averageTimeTaken) }}
                            </div>
                            <v-spacer></v-spacer>
                            <div style="font-size: 14px; font-weight: 400; padding-left: 4px;">
                                People answered correctly -
                            </div>
                            <div style="font-size: 14px; font-weight: 500; padding-left: 4px;">
                                {{ formatAttemptMetric((item?.noOfCorrectAttempt / item?.noOfAttempt) * 100) }}%
                            </div>
                        </div>
                        <v-row style="padding-left: 8px; padding-right: 0px;">
                            <v-divider></v-divider>
                        </v-row>
                        <v-row style="padding-left: 8px; padding-top: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500;">
                            <div style="display:flex;">
                                Response Analytics -

                                <span v-if="!item.myAnswer">Not Attempted</span>
                                <!-- <span v-else>{{ item.status }}</span> -->
                                <span v-else>Attempted</span>
                            </div>
                        </v-row>
                        <v-row style="display:flex; padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 400;">
                            <div>Answered -</div>
                            <div v-if="!item.myAnswer">Skipped</div>
                            <div v-else-if="item.myAnswer && item.questionType == 'MATCH_THE_FOLLOWING'" style="margin-right:24px; margin-left: 8px;">
                                <template>
                                    <span v-for="(answer, index) in generateFormattedAnswer(item.mtfOptions, item.correctAnswer, item.myAnswer, true)" :key="index" :style="{ color: answer.color }">
                                    {{ answer.text }}{{ index < generateFormattedAnswer(item.mtfOptions, item.correctAnswer, item.myAnswer, true).length - 1 ? ',' : '' }}
                                    </span>
                                </template>
                            </div>
                            <div v-else
                            style="padding-left:4px;"
                            :style="item?.isAnswerCorrect? { color:'#06C270' } : { color: '#EE4D37'}">
                                {{ item.isAnswerCorrect ? item.myAnswer + " (Correct)" : item.myAnswer + " (Incorrect)" }}
                            </div>
                        </v-row>
                        <v-row style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 400;" v-if="item.questionType== 'MATCH_THE_FOLLOWING'">
                            <div>Correct Answer -</div>
                            <div style="color:green">{{ generateFormattedAnswer(item.mtfOptions,item.correctAnswer,item.myAnswer,false) }}</div>
                        </v-row>

                        <v-row style="display:flex; padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 400;">
                            <div>Time taken -</div>
                            <div v-if="item.timeTaken != null" style="padding-left: 4px;">
                                {{ item.timeTaken.toFixed(2) }} Sec
                            </div>
                        </v-row>
                        <v-row style="padding-left: 8px; padding-right: 0px">
                            <v-divider></v-divider>
                        </v-row>
                    </v-col>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import CampaignController from '../../controllers/CampaignController';
import staticAssessmentController from '../../controllers/StaticAssessmentController';
import { mapGetters } from "vuex";
import { passageQuestion } from "@/mixins/passageQuestion";


export default {
    name:  'TestReportGenerator',
    mixins: [ passageQuestion ],
    props: {
        reportContents : {
            type: Array,
            required: true,
            default: []
        },
        assessmentType: {
            type: String,
            required: true,
            default: 'dynamic'
        },
        targetUserId: {
            type: String,
            required: true,
            default: '',
        },
        testType: {
            type: String,
            required: false,
            default: 'MAINS'
        },
        campaignId: {
            type: String,
            required: false,
            default: ''
        },
        campaignMetaData:{
            type: Object,
            required: true,
            default: {}
        },
        selectedResult:{
            type: Object,
            required: true,
            default: {}
        }
    },
    data(){
        return {
            totalScore: 0,
            maxMarks: 10
        }
    },
    async mounted(){
        this.totalScore= this.campaignMetaData?.isSkillLevelScoreNormalized ? this.reportContents?.overallNetScore : this.selectedResult?.skills?.reduce((acc, {score})=> acc + (score || 0), 0);
        this.maxMarks = this.campaignMetaData?.isSkillLevelScoreNormalized ? 10 : this.selectedResult?.maxMarks;
        const { testReportURL } = await this.generateTestReport();
        this.$emit('generation-completed', testReportURL);
    },
    methods: {
        async generateTestReport() {
            try {
                await this.$nextTick();

                const htmlContent = this.$refs.reportContents?.outerHTML;
                if (!htmlContent) {
                    throw new Error('No content to generate report');
                }

                const response = await CampaignController.generateTestReport({
                    htmlContent,
                    assessmentType: this.assessmentType,
                    targetUserId: this.targetUserId,
                    campaignId: this.campaignId,
                    testType: this.testType,
                });

                return response;
            } catch (error) {
                console.error(error);
            }
        },
        stripWrappingPTags(html) {
            if (!html) return '';
            return html.replace(/^<p>(.*)<\/p>\s*$/is, '$1');
        },
        // Authors write the gap in a fill in the blanks question as the {blank} token.
        // It is a placeholder, not something a candidate should read, so it renders as
        // a rule - mirrors formatQuestionStatementForDisplay in TestReport.vue.
        formatQuestionStatementForDisplay(statement) {
            if (!statement) return statement;
            return statement.replace(/\{\s*blank\s*\}/gi, "__________");
        },
        imageInOption(questionOptions){
            return questionOptions?.some(option=>(option.optionValue?.startsWith('https://') || option.optionValue?.startsWith('http://') || option.optionValue?.startsWith('blob:')));
        },
        // averageTimeTaken is absent on questions nobody else has attempted yet, and
        // noOfCorrectAttempt / noOfAttempt is NaN when either count is missing (passage
        // sub-questions carry no attempt metrics of their own) or Infinity when the
        // denominator is 0. The on-screen charts already coerce those to 0 - see
        // PieChart.chartData and getTimeChartData - so the PDF reads 0.00 rather than
        // printing NA / NaN for the very same question.
        formatAttemptMetric(value) {
            const number = Number(value);
            return (Number.isFinite(number) ? number : 0).toFixed(2);
        },
        getAlphabet(index) {
            // Convert number to corresponding lowercase letter (0 = a, 1 = b, etc.)
            return String.fromCharCode(97 + index);
        },
        generateFormattedAnswer(mtfOptions, correctAnswer, myAnswer, returnWithColor) {
            // Parse correct answers into a map
            const correctAnswerMap = new Map(
                correctAnswer.split(', ').map(pair => pair.split(':'))
            );

            // First, create a mapping of each option to its letter
            const letterMapping = {};
            mtfOptions.forEach((option, index) => {
                const letter = String.fromCharCode(97 + index); // a, b, c, d
                letterMapping[option.value] = letter;
            });

            // Generate actual answer using correct pairs
            const actualAnswer = [];
            Array.from(correctAnswerMap.entries()).forEach((entry, index) => {
                const number = index + 1;
                const correctCapital = entry[1];
                const letter = letterMapping[correctCapital];
                actualAnswer.push(`${number}-${letter}`);
            });
            if(myAnswer){
                // Generate user answer from myAnswer
                const userAnswer = myAnswer.map((answer, index) => {
                    const number = index + 1;
                    const letter = letterMapping[answer.value];
                    const pair = `${number}-${letter}`;
                    return {
                        pair,
                        isCorrect: pair === actualAnswer[index]
                    };
                });
                if(returnWithColor == true){
                    return userAnswer.map(answer => ({
                        text: answer.pair,
                        color: answer.isCorrect ? 'green' : 'red'
                    }))
                }else{
                    return actualAnswer.join(', ')
                }
            }
            return actualAnswer.join(', ')
        },
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo'
        })
    }
}

</script>
<style scoped>
.question-statement :deep(p) {
    display: inline;
    margin: 0;
}
.question-statement :deep(div) {
    display: inline;
}
</style>